import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './ClickOutsideDirective';
import { AutofocusDirective } from './AutofocusDirective';
import { ContenteditableValueAccessor } from './ContentEditable';
import { TouchTooltipDirective } from './touch-tooltip.directive';
@NgModule({
    declarations: [
        ClickOutsideDirective,
        AutofocusDirective,
        ContenteditableValueAccessor
    ],
    imports: [
        TouchTooltipDirective
    ],

    exports: [
        ClickOutsideDirective,
        AutofocusDirective,
        ContenteditableValueAccessor,
        TouchTooltipDirective
    ],

    providers: [],
})

export class DirectiveModule { }
